export default {"src":"//jsak.mmtcdn.com/tripmoney/apps/v2/landing-pages/_next/static/media/priceTickerLiveTag.e005ee66.svg","height":18,"width":35};